module.exports = __webpack_public_path__ + "static/contribute_lr-e68987b68d69199db79140a2f60918e5.jpg";